import { motion } from "framer-motion";
import { Calendar, MapPin, Users } from "lucide-react";
import { Button } from "../ui/button";

const HERO_BG = "/fira-hero.webp";

const MARQUEE = ["The New Era", "15.11.2026", "Kuala Lumpur", "Exclusively For Fira VIP"];

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.12, ease: "easeOut" },
  }),
};

export const Hero = ({ onReserve }) => (
  <section
    id="hero"
    data-testid="hero-section"
    className="relative flex min-h-screen items-center overflow-hidden"
  >
    <div
      className="absolute inset-0 bg-cover bg-[position:68%_center] lg:bg-[position:110%_center]"
      style={{ backgroundImage: `url(${HERO_BG})` }}
    />
    <div className="absolute inset-0 bg-gradient-to-r from-fira-deep/85 via-fira-deep/65 to-fira-deep/10" />
    <div className="absolute inset-0 bg-gradient-to-t from-fira-deep/85 via-transparent to-fira-deep/45" />

    <div className="relative z-10 mx-auto w-full max-w-7xl px-5 pb-32 pt-32">
      <div className="mx-auto max-w-2xl text-center lg:mx-0 lg:text-left">
        <motion.span
          variants={fadeUp}
          initial="hidden"
          animate="show"
          custom={0}
          data-testid="hero-overline"
          className="inline-block rounded-full border border-fira-pink/40 bg-fira-pink/10 px-5 py-2 text-[11px] font-semibold uppercase tracking-[0.3em] text-fira-rose backdrop-blur-sm"
        >
          Exclusively For Fira VIP Members
        </motion.span>
        <motion.p
          variants={fadeUp}
          initial="hidden"
          animate="show"
          custom={1}
          className="mt-10 text-sm uppercase tracking-[0.5em] text-white/70"
        >
          Fira Worldwide
        </motion.p>
        <motion.h1
          variants={fadeUp}
          initial="hidden"
          animate="show"
          custom={2}
          data-testid="hero-title"
          className="mt-3 text-6xl font-extrabold uppercase leading-[0.95] tracking-tight text-white md:text-7xl lg:text-8xl"
        >
          The New{" "}
          <span className="text-glow text-fira-rose">Era</span>
        </motion.h1>
        <motion.p
          variants={fadeUp}
          initial="hidden"
          animate="show"
          custom={3}
          data-testid="hero-subtitle"
          className="font-display mt-5 text-xl italic text-fira-rose md:text-2xl"
        >
          5 Tahun Perjalanan. Ribuan Kenangan. Satu Chapter Baru.
        </motion.p>
        <motion.div
          variants={fadeUp}
          initial="hidden"
          animate="show"
          custom={4}
          className="text-backdrop relative mx-auto mt-6 max-w-2xl space-y-3 rounded-3xl px-4 py-3 text-sm leading-relaxed text-white/75 md:text-base lg:mx-0"
        >
          <p>Selama ini kita bertemu melalui chart, signal, livetrade dan komuniti. Kini tiba masanya untuk kita bertemu secara bersemuka.</p>
          <p>Join Fira dan team Fira Worldwide dalam sebuah acara eksklusif untuk appreciate journey kita bersama, meraikan VIP dan menyaksikan permulaan sebuah era baru.</p>
        </motion.div>
        <motion.div
          variants={fadeUp}
          initial="hidden"
          animate="show"
          custom={5}
          data-testid="hero-info-bar"
          className="mx-auto mt-10 flex w-fit flex-col items-center gap-4 rounded-2xl border border-white/10 bg-white/5 px-5 py-5 backdrop-blur-xl sm:flex-row sm:gap-x-8 md:px-[25px] lg:mx-0 lg:px-[25px]"
        >
          <div className="flex items-center gap-3">
            <Calendar className="h-5 w-5 text-fira-rose" />
            <span className="text-sm font-medium">15 November 2026</span>
          </div>
          <div className="flex items-center gap-3">
            <MapPin className="h-5 w-5 text-fira-rose" />
            <span className="text-sm font-medium">Kuala Lumpur</span>
          </div>
          <div className="flex items-center gap-3">
            <Users className="h-5 w-5 text-fira-rose" />
            <span className="text-sm font-medium">Eksklusif Fira VIP</span>
          </div>
        </motion.div>
        <motion.div
          variants={fadeUp}
          initial="hidden"
          animate="show"
          custom={6}
          className="flex flex-col items-center lg:items-start"
        >
          <Button
            onClick={onReserve}
            data-testid="hero-reserve-btn"
            className="btn-lux mt-10 rounded-full px-10 py-6 text-base font-bold tracking-widest text-white transition-all duration-300 hover:scale-105"
          >
            RESERVE MY SEAT
          </Button>
          <p data-testid="hero-note" className="mt-6 max-w-xl text-xs leading-relaxed text-white/50">
            Eksklusif untuk existing Fira VIP. Tempat adalah terhad. Pengesahan seat tertakluk kepada deposit trading mengikut kategori.
          </p>
        </motion.div>
      </div>
    </div>

    <div
      data-testid="hero-marquee"
      className="absolute inset-x-0 bottom-0 z-10 overflow-hidden border-t border-white/10 bg-fira-deep/60 py-3 backdrop-blur-md"
    >
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {[...MARQUEE, ...MARQUEE].map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-10 text-xs font-semibold uppercase tracking-[0.4em] text-white/50"
          >
            {item}
            <span className="text-fira-pink">◆</span>
          </span>
        ))}
      </div>
    </div>
  </section>
);
